/** 设置 -> 规划 -> 流程、角色字段与案件流程变体（第二阶段 P2-2b，P21-P22）。 */
export default {
  procedure: {
    title: '流程调整',
    description:
      '可重命名步骤、省略可选步骤、在流程允许的范围内设定期限，并列出额外文件。法定步骤已锁定。已开启的案件保留其开始时的流程。',
    base: '流程 {{id}}，版本 {{version}}',
    active: '正在使用的调整：{{hash}}',
    none: '没有调整：新案件按已发布的流程办理。',
    outdated: '这些调整是为较旧的流程版本制定的。新案件仍在使用；重新保存即可应用于当前版本。',
    unavailable: '无法加载正在使用的调整，因此无法创建新案件。请重新保存，或使用已发布的流程。',
    locked: '已锁定（法定）',
    labelIn: '{{locale}} 名称',
    stages: '步骤',
    transitions: '操作',
    clocks: '期限',
    skip: '省略此步骤',
    durations: '期限长度',
    durationRange: '介于 {{min}} 与 {{max}} 之间',
    durationFixed: '由流程固定',
    durationTable: '由规则表设定；没有规则匹配时使用此值。',
    durationOverride: '以固定期限取代规则表',
    durationOverrideHint: '所有新案件均采用此期限，不论规则表如何规定。留空则沿用规则表。',
    documentTypes: '额外文件',
    documentTypesHint: '列在每个新案件上。上传这些文件将在后续版本提供。',
    documentTypeId: '代码',
    documentTypeLabel: '名称',
    documentTypeExtensions: '文件类型（例如 .pdf、.jpg）',
    addDocumentType: '添加文件',
    removeDocumentType: '移除',
    save: '保存调整',
    saving: '正在保存调整…',
    saved: '调整已保存。新案件将按此办理。',
    deactivate: '使用已发布的流程',
    deactivated: '新案件按已发布的流程办理。',
    invalid: '这些调整被拒绝：',
    issues: {
      overlay_base_mismatch: '打开此页面后流程已更改。请重新加载页面并再次保存。',
      overlay_unknown_element: '这些调整中的某个步骤、操作或期限不在当前流程中。请重新加载页面后重试。',
      overlay_touches_locked:
        '已锁定（法定）的步骤、操作和期限不能重命名或更改；如果省略某个步骤会更改其中之一，则不能省略该步骤。',
      overlay_invalid_label: '每个名称需要 1 至 200 个字符。',
      overlay_skip_not_optional: '只能省略可选步骤。',
      overlay_duration_not_adjustable: '由流程固定的期限不能改为其他长度。',
      overlay_duration_out_of_bounds: '期限长度必须是其下方所示范围内的整数。',
      overlay_document_type_invalid:
        '每份额外文件需要：一个以字母开头、由 2 至 40 个小写字母、数字或下划线组成且尚未使用的代码（例如 site_photos），一个名称，以及 1 至 10 种文件类型（例如 .pdf）。额外文件最多 20 份。',
      overlay_override_not_table: '固定期限只能取代由规则表设定的截止期限。',
      overlay_duration_conflict: '截止期限只能设定期限或取代规则表的固定期限，不能两者都设。',
      overlay_document_type_clash: '额外文件不能沿用流程已列出文件的代码。',
      overlay_duration_table_and_input: '此截止期限的长度取自规则表及分发本身，因此调整不能更改。',
    },
    download: '下载流程：',
    downloadJson: 'JSON 文件',
    downloadBpmn: 'BPMN 2.0 流程图',
    downloadDmn: 'DMN 1.3 规则表',
    loadFailed: '无法加载流程。',
    notForNewCases:
      '这些调整是为新案件已不再采用的流程制定的，因此新案件按已发布的流程办理，不含这些调整。已开立的案件保留这些调整。请在下方当前流程上重新调整，或使用已发布的流程。',
    caseDocumentTypes: '此流程要求的文件：{{list}}',
  },
  roles: {
    groupsFor: '{{role}} 角色的群组',
    hint: '具有管理员或发布者角色的成员，在流程指定该角色之处以此角色办理。',
    names: {
      reviewer: '审核人',
      approver: '批准人',
      osc_officer: 'OSC 官员',
      technical_department: '技术部门',
      applicant: '申请人',
    },
    notYetInUse: '目前使用中的流程尚未指定此角色；待有流程指定时，在此绑定的群组即获得该角色。',
  },
} as const
